import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import BlockUi from 'react-block-ui';

class UncompletedSalesStats extends Component {
	render() {
		const { loading, data, t } = this.props;
		const { pending, notApproved, created } = data || { pending: null, notApproved: null, created: null };

		return <BlockUi blocking={loading}>
			<div className='general-item-list'>
				<div className='item'><span>{t('PaymentStatusType_NotApproved')}</span><span className='pull-right'>{notApproved}</span></div>
				<div className='item'><span>{t('PaymentStatusType_Pending')}</span><span className='pull-right'>{pending}</span></div>
				<div className='item'><span>{t('PaymentStatusType_Created')}</span><span className='pull-right'>{created}</span></div>
			</div>
		</BlockUi>;
	}
}

export default withTranslation()(UncompletedSalesStats);